import { connect } from "react-redux";
import QueuesComponent from "../../Components/Queues/QueuesComponent";
import { setQueues } from "../../Redux/Actions/QueuesActions";

const mapStateToProps = (state) => ({
    LICENCES: state.reducer.LICENCES,
    SCOPES_NAMES : state.reducer.SCOPES_NAMES,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    MEDIAS : state.reducer.MEDIAS,
    SCOPE_AVAILABLE_LICENCES : state.reducer.SCOPE_AVAILABLE_LICENCES,
    QUEUES:state.reducer.QUEUES,
    AGENTS : state.reducer.AGENTS

});
const mapDispatchToProps = (dispatch) => ({
  setQueues: (queues) => dispatch(setQueues(queues)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(QueuesComponent);